import type { AppLifecycleInput, AppLifecyclePhase } from "./types";

export const APP_LIFECYCLE_PHASES = ["new", "building", "deployed", "live", "growing"] as const satisfies readonly AppLifecyclePhase[];

export const APP_LIFECYCLE_PHASE_LABELS: Record<AppLifecyclePhase, string> = {
	new: "Idea",
	building: "Building",
	deployed: "Deployed",
	live: "Live",
	growing: "Growing",
};

export const APP_LIFECYCLE_PHASE_PRIORITY: Record<AppLifecyclePhase, number> = {
	growing: 0,
	live: 1,
	deployed: 2,
	building: 3,
	new: 4,
};

export function getAppLifecyclePhase(app: AppLifecycleInput, opts: { hasGrowth?: boolean } = {}): AppLifecyclePhase {
	if (app.deployment?.isLive && opts.hasGrowth) return "growing";
	if (app.deployment?.isLive || app.status === "Live" || app.status === "live") {
		return "live";
	}
	if (
		app.deployment?.submittedForReview ||
		app.deployment?.buildUploaded ||
		app.deployment?.appCreated ||
		app.status === "Built" ||
		app.status === "Deployed" ||
		app.status === "Reviewing" ||
		app.status === "Ready" ||
		app.status === "ready"
	) {
		return "deployed";
	}
	if (app.status === "Built" || app.status === "Generated" || app.status === "generated" || app.status === "Building" || app.status === "Local") {
		return "building";
	}
	return "new";
}
